import { Alpine } from "alpinejs";

interface ScrollPosition {
	position: number;
	shouldAnimate: boolean;
	init: CallableFunction;
	getClampedPosition: CallableFunction;
	handleScroll: CallableFunction;
	easeIn: CallableFunction;
	easeOut: CallableFunction;
}

// Translates a elements position in the window to a decimal. Then do with it what you want!
const scrollPosition = (defaultPosition = 0): ScrollPosition => {
	return {
		position: defaultPosition,
		shouldAnimate: true,

		init() {
			if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
				this.handleScroll();
				window.addEventListener("scroll", () => this.handleScroll());
			} else {
				this.shouldAnimate = false;
			}
		},

		getClampedPosition(min: number, max: number): number {
			if (this.position <= min) return 0;
			if (this.position >= max) return 1;
			return (this.position - min) / (max - min);
		},

		handleScroll(): void {
			this.position = getPercentage(this.$el) ?? defaultPosition;
		},

		easeIn,
		easeOut,
	};
};

const getPercentage = (
	element: HTMLElement | undefined,
): undefined | number => {
	if (!element) return;

	const rect = element.getBoundingClientRect();
	const viewportHeight = window.innerHeight;

	const totalScrollDistance = rect.height + viewportHeight;
	const scrollPassed = viewportHeight - rect.top;

	let percent = scrollPassed / totalScrollDistance;

	return Math.max(0, Math.min(1, percent));
};

export const easeOut = (t: number) => {
	return ((t * (2 - t)) / 100) * -1;
};

export const easeIn = (t: number) => {
	return t * t;
};

Alpine.data("scrollPosition", scrollPosition);
